import React from 'react';

import Button from '../../UI/button/Button';
import { Title } from '../../UI/title/Title';
import Wrapper from '../../UI/wrapper/Wrapper';
import Gallery from '../../gallery/Gallery';

import styles from './Hero.module.scss';

const Hero = () => {
    const title = 'Premium Ghost Themes to Captivate Any Audience';
    const excerpt = `Exceptional Ghost themes for every publisher, from leading media sites to personal blogs, 
    craft your vision seamlessly.`;

    return (
        <section className={styles.hero__section}>
            <Wrapper className={styles.hero__wrapper}>
                <Title text={title} size="xl" className={styles.heading} />

                <p className={`excerpt body-lg excerpt-wrap ${styles.excerpt} `}>{excerpt}</p>
                <div className={styles.buttons}>
                    <Button buttonUrl="/themes" ariaLabel="Discover Themes" color="blue">
                        Discover Themes
                    </Button>
                    <Button
                        ariaLabel="Learn more"
                        color="standard"
                        buttonUrl="/themes/reporter"
                        target>
                        Learn more
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none">
                            <path
                                d="M6.43674 5.19931L12.7123 5.28769M12.7123 5.28769L12.8007 11.5633M12.7123 5.28769L5.28769 12.7123"
                                stroke="#0A163C"
                                strokeWidth="1.7"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </Button>
                </div>
            </Wrapper>
            <Gallery />
        </section>
    );
};

export default Hero;
